import React from 'react';
import { Badge } from './ui/badge';
import { Laptop } from 'lucide-react';
import { ApiService } from '../services/api';

export function DemoIndicator() {
  const [isVisible, setIsVisible] = React.useState(false);
  const [envInfo, setEnvInfo] = React.useState({
    isFigmaMake: false,
    isUsingLiveApi: true,
    hostname: 'unknown'
  });

  React.useEffect(() => {
    // Check environment info
    const info = ApiService.environmentInfo;
    setEnvInfo(info);
    
    // Show indicator only if we're in Figma Make environment
    setIsVisible(info.isFigmaMake);
  }, []);

  if (!isVisible) return null;

  return null;
}